import { Box, Typography } from "@mui/material";
import WhyGenomicsImage from "assets/images/Why_Genomics.jpg";
import CancerAndGenomicsImage from "assets/images/Cancer_and_Genomics.jpg";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import GLButton from "components/v3/sharedComponents/GLButton";

const ProactiveHealthResources = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: {
          xs: 4,
          md: "65px"
        },
        padding: {
          xs: "32px 24px",
          md: "64px 32px 32px 32px"
        },
        textAlign: "center"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          textAlign: "center"
        }}
      >
        <Typography sx={{ typography: { xs: "h4", md: "h3" } }}>
          Proactive Health Resources
        </Typography>
        <Typography variant="body">
          Genomic insights, research, and disease-related resources.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: "30px",
          margin: "auto"
        }}
      >
        <Box
          component="a"
          href={PATHS.WHY_GENOMICS}
          sx={{
            alignItems: "center",
            backgroundImage: `url(${WhyGenomicsImage})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "32px 4px 32px 32px",
            boxSizing: "border-box",
            display: "flex",
            flexBasis: "100%",
            flexDirection: "column",
            minHeight: {
              xs: "240px",
              md: "276px"
            },
            justifyContent: "space-between",
            padding: "30px",
            textAlign: "center",
            textDecoration: "none"
          }}
          target="_blank"
        >
          <Typography variant="body_strong_xl_white">Why Genomics?</Typography>
          <GLButton
            buttonType="secondary-transparent"
            sx={{
              border: `1px solid ${COLORS.WHITE}`,
              height: "auto !important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "transparent",
                borderRadius: "16px 8px 16px 16px"
              }
            }}
          >
            <Typography variant="body_strong_white">Learn More</Typography>
          </GLButton>
        </Box>
        <Box
          component="a"
          href={PATHS.CANCER_AND_GENOMICS}
          sx={{
            alignItems: "center",
            backgroundImage: `url(${CancerAndGenomicsImage})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "4px 32px 32px 32px",
            boxSizing: "border-box",
            display: "flex",
            flexBasis: "100%",
            flexDirection: "column",
            minHeight: {
              xs: "240px",
              md: "276px"
            },
            justifyContent: "space-between",
            padding: "30px",
            textAlign: "center",
            textDecoration: "none"
          }}
          target="_blank"
        >
          <Typography variant="body_strong_xl_white">
            Cancer & Genomics
          </Typography>
          <GLButton
            buttonType="secondary-transparent"
            sx={{
              border: `1px solid ${COLORS.WHITE}`,
              height: "auto !important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "transparent",
                borderRadius: "16px 8px 16px 16px"
              }
            }}
          >
            <Typography variant="body_strong_white">Learn More</Typography>
          </GLButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ProactiveHealthResources;
